import { render, staticRenderFns } from "./IncidentRow.vue?vue&type=template&id=de42b870"
import script from "./IncidentRow.vue?vue&type=script&lang=js"
export * from "./IncidentRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports